import { Field } from "react-final-form";
import { __ } from "@sportnet/ui/utilities";
import { connect } from "react-redux";
import { nonSharedSaleChanellsListSelector } from "../../SaleChannels/selectors";
import { rem } from "polished";
import FormField from "@sportnet/ui/FormField";
import React from "react";
import Segment from "@sportnet/ui/Segment";
import Skeleton from "@sportnet/ui/Skeleton";
import Tabber from "@sportnet/ui/Tabber";
import apiEshop from "../../../service/apiEshop";
import styled, { css } from "styled-components";

const Wrapper = styled.div`
  display: ${({ $hidden }) => ($hidden ? "none" : "block")};
`;

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};

  > .separator {
    width: ${rem(20)};
  }
`;

const SeparatorWrapper = styled.div`
  ${(props) => {
    return css`
      width: ${rem(20 * props.indent)};
    `;
  }}
  float: left;
  display: flex;
  align-self: center;
`;

const Separator = styled.div`
  float: left;
  height: ${rem(1)};
  border: ${rem(1)} dashed #ebebeb;
  width: 100%;
`;

const FormFieldWrapper = styled.div`
  > div {
    margin: 0 !important;
  }

  > div > div {
    padding: 0 !important;
  }
`;

const Category = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`;

const CategoriesWrapper = styled.div``;

const SalesChannelCategories = ({ salesChannels, org, hidden }) => {
  const [salesChannelsCategories, setSalesChannelsCategories] = React.useState(
    [],
  );
  const [activeSalesChannel, setActiveSalesChannel] = React.useState(null);
  const [
    isFetchingSalesChannelsCategories,
    setIsFetchingSalesChannelsCategories,
  ] = React.useState(false);

  React.useEffect(() => {
    if (activeSalesChannel) {
      setIsFetchingSalesChannelsCategories(true);
      apiEshop
        .adminSaleschannelGetCategoriesTree(org, activeSalesChannel._id)
        .then((data) => {
          setSalesChannelsCategories(data.categories || []);
        })
        .catch((e) => {
          console.error(e);
          alert(__("Nepodarilo sa získať zoznam kategórií"));
        })
        .finally(() => {
          setIsFetchingSalesChannelsCategories(false);
        });
    }
  }, [org, activeSalesChannel]);

  React.useEffect(() => {
    if ((salesChannels || []).length && !activeSalesChannel) {
      setActiveSalesChannel(salesChannels[0]);
    }
  }, [salesChannels, activeSalesChannel]);

  const renderCategories = (items = [], indent = 0) => {
    return (
      <CategoriesWrapper>
        {items.map((category, idx) => {
          return (
            <Category key={idx}>
              <FlexRow>
                {indent > 0 && (
                  <SeparatorWrapper indent={indent}>
                    <Separator />
                  </SeparatorWrapper>
                )}
                <Field
                  name={`salesChannelsCategories.k${category._id}`}
                  type="checkbox"
                >
                  {({ input: { checked, onChange } }) => (
                    <FormFieldWrapper>
                      <FormField
                        checked={checked}
                        onChange={onChange}
                        label={category.name}
                        type="checkbox"
                      />
                    </FormFieldWrapper>
                  )}
                </Field>
              </FlexRow>
              {category.categories &&
                renderCategories(category.categories, indent + 1)}
            </Category>
          );
        })}
      </CategoriesWrapper>
    );
  };

  return (
    <Wrapper $hidden={hidden}>
      <Segment raised>
        <Tabber
          items={(salesChannels || []).map((i) => i.name)}
          active={activeSalesChannel ? activeSalesChannel.name : ""}
          onClickItem={(item) => {
            const salesChannel = salesChannels.find((i) => i.name === item);
            if (salesChannel) {
              setActiveSalesChannel(salesChannel);
            }
          }}
        >
          <Segment>
            {isFetchingSalesChannelsCategories ? (
              <SkeletonWrapper>
                <FlexRow>
                  <Skeleton height={16} width={16} />
                  <Skeleton height={12} width={48} borderRadius={12} />
                </FlexRow>
                <FlexRow>
                  <Skeleton height={16} width={16} />
                  <Skeleton height={12} width={64} borderRadius={12} />
                </FlexRow>
                <FlexRow>
                  <Skeleton height={16} width={16} />
                  <Skeleton height={12} width={32} borderRadius={12} />
                </FlexRow>
                <FlexRow>
                  <Skeleton height={16} width={16} />
                  <Skeleton height={12} width={92} borderRadius={12} />
                </FlexRow>
              </SkeletonWrapper>
            ) : (
              renderCategories(salesChannelsCategories || [])
            )}
          </Segment>
        </Tabber>
      </Segment>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  org: state.selectedOrg,
  salesChannels: nonSharedSaleChanellsListSelector(state),
});

export default connect(mapStateToProps)(SalesChannelCategories);
